import {
  AvailableRecordTypeFragment,
  FieldType,
} from '../../__generated__/graphql';
import {
  ExtraFieldInternalValue,
  mapFormValueToInternalValue,
  mapInternalValueToFormValue,
} from './extraFieldInternalValue';

export const recordTypeFormKey = 'extraFields_recordTypeName';

// From form to ExtraFieldInternalValue
export const collectFormDataExtraFields = (
  formData: Record<string, any>,
): ExtraFieldInternalValue[] => {
  const result = Object.keys(formData)
    .filter((key) => key.startsWith('customerField:'))
    .map((key) => {
      const { fieldApiName, type } = parseFieldApiName(key);
      return {
        fieldApiName,
        type,
        internalValue: mapFormValueToInternalValue(formData[key], type),
      };
    });
  const recordTypeName = formData[recordTypeFormKey];
  if (recordTypeName) {
    result.push({
      fieldApiName: 'RecordTypeName',
      type: FieldType.Textarea,
      internalValue: { value: recordTypeName },
    });
  }
  return result;
};

//inverse of collectFormDataExtraFields
export const getFormValuesFromExtraFields = (
  extraFields: readonly ExtraFieldInternalValue[], // in TS the same as ExtraFieldInput
  recordTypeName: string, // because it is not presented in ExtraFieldValueShortFragment
): Record<string, unknown> => {
  const formValues = extraFields.reduce((acc, v) => {
    if (v.fieldApiName === 'RecordTypeName') {
      // skip RecordTypeName extra field, it is added later in that function
      return acc;
    }
    const key = getExtraFieldInputName(v.fieldApiName, v.type);
    acc[key] = mapInternalValueToFormValue(v);
    return acc;
  }, {} as Record<string, unknown>);
  if (recordTypeName) {
    formValues[recordTypeFormKey] = recordTypeName;
  }
  return formValues;
};

export const getExtraFieldInputName = (
  fieldApiName: string,
  type: FieldType,
) => {
  return `customerField:${type}:${fieldApiName}`;
};

export const parseFieldApiName = (name: string) => {
  const parts = name.split(':');
  return {
    type: parts[1] as FieldType,
    fieldApiName: parts[2],
  };
};

export function hasSeveralRecordTypes(
  availableRecordTypes: readonly AvailableRecordTypeFragment[],
) {
  return availableRecordTypes.length >= 2;
}

export function getRecordType(
  recordTypeId: string,
  availableRecordTypes: readonly AvailableRecordTypeFragment[],
): string | null {
  const recordType = availableRecordTypes.find((rt) => rt.Id === recordTypeId);
  return recordType?.DeveloperName ?? null;
}
